import { render, staticRenderFns } from "./itinerary-accordion.vue?vue&type=template&id=6c1ff285"
import script from "./itinerary-accordion.vue?vue&type=script&lang=js"
export * from "./itinerary-accordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports